export function img(_ctx) {
    return {
        styles: {
            main: { radius: 0 },
        },
    };
}
